<app-todo
    *ngIf="move"
    [label]="'REAL_ESTATE_AGENT.DASHBOARD.DETAIL.ORDERED' | translate: { name: move | userName }"
    [state]="move.track.transferee.energyOfferConfirmed"
>
    <app-todo-template *todoStateChecked>
        <span>{{ move.track.lastModifiedOn.energyOfferConfirmed | formatDate }}</span>
    </app-todo-template>
</app-todo>
